import TYPES from './types';
import COMMON_TYPES from '../../../actions/types';
import * as analytics from '../../../analytics';
import { formatFormStatus } from '../utils';
import { showNotificationLayer } from '../../../actions/notification';
import { changeStatus } from '../../../api/settings-user';

const loadingPostManager = () => ({ type: COMMON_TYPES.formPostWatingResponse });

export const enableOrDisable = params => {
  return dispatch => {
    dispatch(loadingPostManager());

    changeStatus(params.formParams)
      .then(response => {
        dispatch(loadingPostManager());
        dispatch(toggleFormChangeStatusLayer());

        dispatch({
          type: TYPES.updateItemListing,
          payload: response,
        });

        dispatch(
          showNotificationLayer(`O usuário ${response.data.name} foi atualizado!`)
        );
      })
      .catch(responseFail => {
        dispatch(loadingPostManager());

        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response.data,
        });
      })
  }
};

export const toggleFormChangeStatusLayer = params => {
  if(params && params.id) {
    //ga
    analytics.registerEvent({
      category: analytics.categories.user,
      action: analytics.actions.userChangeStatus,
    });

    return [
      { type: COMMON_TYPES.toggleLayer, payload: 'changeStatus' },
      {
        type: COMMON_TYPES.formInitializeValues,
        payload: formatFormStatus(params),
      },
    ];
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.formClearValues },
  ];
};
